module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f6a7.cc41695a.svg";